import { compose } from 'redux';
import { Map } from 'immutable';
import { connect, makeScrollable, QuizSession, QuizSessionResult, scrollToItem } from '@instructure/quiz-core';
import { RESULTS_SCROLL_KEY } from '@instructure/quiz-common';
import { GradingHeader as GradingHeaderPresenter } from './presenter';
export var mapStateToProps = function mapStateToProps(state) {
  var quizSessionId = state.getIn(['quizSessions', 'activeQuizSessionId']);
  var quizSession = new QuizSession(state.getIn(['quizSessions', quizSessionId]));
  var qsrId = quizSession.authoritativeResult;
  var authoritativeResult = new QuizSessionResult(state.getIn(['quizSessionResults', qsrId]));
  var sessionItemMap = state.get('sessionItems', Map());
  var sessionItemResults = state.get('sessionItemResults', Map()).toList().filter(function (sir) {
    return sir.get('quizSessionId') === quizSessionId;
  }).map(function (sir) {
    var id = sir.get('id');
    var sessionItem = sessionItemMap.get(id);
    return sir.set('questionNumber', sessionItem === null || sessionItem === void 0 ? void 0 : sessionItem.get('questionNumber'));
  });
  return {
    quizSession: quizSession,
    quizSessionResult: authoritativeResult,
    scrollKey: RESULTS_SCROLL_KEY,
    sessionItemResults: sessionItemResults
  };
};
var mapDispatchToProps = {
  scrollToItem: scrollToItem
};
export var GradingHeader = compose(connect(mapStateToProps, mapDispatchToProps), makeScrollable)(GradingHeaderPresenter);
export default GradingHeader;